<template>
  <div class="debrief">
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="upload">
        <div class="label">
          <i class="fa fa-cog fa-spin fa-3x fa-fw"></i> <br/>
          {{ message }}
        </div>
      </div>
    </transition>
    <div class="header-intervention">
      <div class="header-info">
        {{ showCountLabel(reponse_count) }}
      </div>
      <div class="button-content">
        <div class="button" v-on:click="back() " v-if="!auditPhoto && (!signature || audit)">
          <i class="fa fa-times" aria-hidden="true"></i> Annuler
        </div>
        <div class="button" v-on:click="signatureBack()" v-if="(auditPhoto || signature)">
          <i class="fa fa-chevron-left" aria-hidden="true"></i> Retour
        </div>
        <div class="button" v-on:click="send()" v-if="signature && checked || audit && auditPhoto">
          <i class="fa fa-paper-plane" aria-hidden="true"></i> Envoyer
        </div>
        <div class="button" v-on:click="signatureShow()" v-if="reponse_count === 0 && auditPhoto && !audit">
          <i class="fa fa-pencil" aria-hidden="true"></i> Signature
        </div>
        <div class="button" v-on:click="signatureShow()" v-if="reponse_count === 0 && !auditPhoto && !signature">
          <i class="fa fa-camera" aria-hidden="true"></i> Photo
        </div>
      </div>
    </div>
    <b-container :class="wrapper_class">
      <div class="etatBox" v-show="!signature && !auditPhoto">
        <div v-html="getEtat(intervention)"></div>
      </div>
      <div class="content-arbre" v-show="!signature && !auditPhoto">

      </div>
      <div class="photo" v-show="auditPhoto">
        <div class="picture" v-for="file in files">
          <div class="label">{{file.description}}</div>
          <img class="preview" v-bind:src="file.image" alt="">
          <div class="options">
            <div v-if="audit" class="rename" v-on:click="rename(file)">Renommer</div>
            <div v-if="!audit" class="rename" v-on:click="renameSelector(file)">Renommer</div>
            <div class="delete" v-on:click="deleteFile(file)">Supprimer</div>
          </div>
        </div>
        <div class="buttonPhoto" v-on:click="selectPicture">
          <i class="fa fa-camera" aria-hidden="true"></i> Ajouter des photos
        </div>
        <div class="buttonPhoto" v-show="files.length !== 0" v-on:click="uploadPicture">
          <i class="fa fa-cloud-upload" aria-hidden="true"></i> Envoyer les photos
        </div>
        <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" multiple>
      </div>
      <div class="signature" v-show="signature && !audit">
        <input type="checkbox" id="checkbox" v-model="checked"> En cochant la case, Je déclare avoir effectué et terminé mon intervention.
        <br>
        <br>
        <div v-show="checked">
          <div class="rules" v-if="intervention.rdvClient">
             Signature de Mme ou M. {{ getData('cmdAcces', 'clientNom') }} {{ getData('cmdAcces', 'clientPrenom') }} (ou son représentant) :
          </div>
          <div class="rules" v-if="!intervention.rdvClient">
            Signature du technicien
          </div>
          <canvas id="signature-pad" class="signature-pad"></canvas>
          <div class="button" v-on:click="reset()">
            <i class="fa fa-eraser" aria-hidden="true"></i> Réinitialiser
          </div>
        </div>
      </div>
      <modal name="selector" width="360" height="70">
        <div class="title-selector">
          Sélection du nom de la photo :
        </div>
        <select class="select" v-model="selected" @change="closModal()">
          <option v-if="intervention.typeId === type.type_intervention_id" v-for="type in type_photo"  v-bind:value="type.nom">{{ type.nom }}</option>
        </select>
      </modal>
    </b-container>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'
export default {
  name: 'debrief',
  props: {
    isTest: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: '',
      type_photo: [],
      files: [],
      renameFile: null,
      intervention_id: null,
      debrief: {},
      signature: false,
      checked: false,
      reponse_count: 0,
      auditPhoto: false,
      signaturePad: null,
      intervention: {},
      debrief_data: null,
      audit: false,
      upload: false,
      message: '',
      waiting: {
        position: 0,
        total: 0
      },
      wrapper_class: 'debrief-content'
    }
  },
  methods: {
    showCountLabel: function (reponseCount) {
      if (reponseCount === 0) {
        return 'Débrief OK'
      }
      if (reponseCount > 1) {
        return reponseCount + ' questions restantes'
      }
      if (reponseCount === 1) {
        return reponseCount + ' question restante'
      }
    },
    reset: function () {
      this.signaturePad.clear()
    },
    back: function () {
      if (!this.isTest) {
        this.$router.push('/intervention/' + this.intervention_id)
      } else {
        this.$parent.selectedArbre = 0
        this.$parent.selected = false
      }
    },
    getEtat: function (intervention) {
      let html = 'Etat box : '
      if (intervention.etat === 'OK') {
        html += '<label style="font-size: 20px;color: green;">OK</label>'
      } else if (intervention.etat === 'NOK') {
        html += '<label style="font-size: 20px;color: red;">NOK</label>'
      } else {
        html += '<label style="font-size: 20px;color: orange;">-</label>'
      }
      return html
    },
    signatureShow: function () {
      if (this.audit) {
        this.auditPhoto = true
      } else {
        if (this.auditPhoto) {
          this.signature = true
          this.auditPhoto = false
        }
        if (!this.signature) {
          this.auditPhoto = true
        }
      }
      if (this.auditPhoto) {
        let send = []
        $('.content > .question').each(function (index) {
          if ($(this).is(':visible')) {
            if ($(this).find('.reponse-button').hasClass('check')) {
              send.push({
                question_id: $(this).find('.reponse-button.check').data('question-id'),
                response_id: $(this).find('.reponse-button.check').data('reponse-id')
              })
            }
            if ($(this).find('.reponse-input > input').val() !== '' && $(this).find('.reponse-input > input').val() !== undefined) {
              send.push({
                question_id: $(this).find('.reponse-input').data('question-id'),
                response_id: null,
                response_text: $(this).find('.reponse-input > input').val()
              })
            }
          }
        })
        this.debrief_data = send
      }
      window.scrollTo(0, 0)
    },
    getData: function (key, value) {
      if (this.intervention[key] !== undefined) {
        if (this.intervention[key][value] !== undefined) {
          return this.intervention[key][value]
        }
      }
    },
    selectPicture: function () {
      this.$refs.fileInput.click()
    },
    uploadPicture: function () {
      if (this.waiting.position >= this.files.length) {
        this.upload = false
        this.waiting.position = 0
        this.waiting.total = 0
        this.files.length = 0
        return
      }
      if (!this.isTest) {
        this.upload = true
        this.waiting.total = this.files.length
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total
        this.uploadPictureServer(this.files[this.waiting.position])
      } else {
        this.upload = true
        this.waiting.total = this.files.length
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total
        this.waiting.position++
        this.upload = false
        this.$toast('L\'envoie de photo à été effectué avec succès')
      }
    },
    uploadPictureServer: function (data) {
      this.$http.post('intervention/' + this.intervention_id + '/photo', JSON.stringify(data)).then(response => {
        this.response = response.json().then((data) => {
          this.waiting.position++
          this.uploadPicture()
        })
      }, (response) => {
        console.log(response)
      })
    },
    rename: function (file) {
      file.description = prompt('Nommer la photo', file.description)
    },
    renameSelector: function (file) {
      this.renameFile = file
      this.$http.get('typephoto').then(response => {
        this.response = response.json().then((data) => {
          this.type_photo = data
          this.start = false
        })
      }, (response) => {
        this.start = false
      })
      this.$modal.show('selector')
    },
    closModal: function () {
      this.renameFile.description = this.selected
      this.$modal.hide('selector')
    },
    deleteFile: function (file) {
      let i = this.files.indexOf(file)
      if (i !== -1) {
        this.files.splice(i, 1)
      }
    },
    onFileChange: function (e, prefill) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      let _this = this
      for (let i in files) {
        let file = files[i]

        if (!(file instanceof File)) {
          continue
        }
        let reader = new FileReader()
        reader.onload = function (e) {
          let image = new Image()
          image.src = e.target.result
          image.onload = function () {
            let maxWidth = 1024
            let maxHeight = 768
            let imageWidth = image.width
            let imageHeight = image.height

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth
                imageWidth = maxWidth
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight
                imageHeight = maxHeight
              }
            }
            let canvas = document.createElement('canvas')
            canvas.width = imageWidth
            canvas.height = imageHeight
            image.width = imageWidth
            image.height = imageHeight
            let ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight)
            _this.files.push({
              image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
              description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
            })
          }
        }
        reader.readAsDataURL(file)
      }
    },
    signatureBack: function () {
      if (this.signature) {
        this.auditPhoto = true
        this.signature = false
      } else {
        this.signature = false
        this.auditPhoto = false
      }
    },
    send: function () {
      if (!this.isTest) {
        let data = {}
        data.debrief = this.debrief_data
        if (this.signaturePad.isEmpty() && !this.audit) {
          this.$toast.bottom('La signature est vide')
          return
        }
        data.signature = 'close'
        if (!this.signaturePad.isEmpty()) {
          data.signature = this.signaturePad.toDataURL('image/jpeg')
        }
        if (this.audit && this.files.length !== 0) {
          this.$toast.bottom('Merci de cliquer sur "Envoyer les photos" en bas de page')
          return
        }
        this.$http.post('intervention/' + this.intervention_id + '/action/debrief', JSON.stringify(data)).then(response => {
          this.response = response.json().then((data) => {
            this.start = false
            this.$removeItem(this.intervention_id)
            this.$router.push('/intervention/' + this.intervention_id)
            this.$toast.bottom('Intervention terminée')
          })
        }, (response) => {
          this.start = false
          if (response.status === 403) {
            this.$router.push('/intervention/' + this.intervention_id)
            this.$toast.bottom('Le debrief n\'a pas pu être debriefer car la date de rendez vous a été modifié !')
          }
          this.$toast.bottom('Une erreur est survenue lors de l\'envoi du debrief')
        })
      } else {
        this.back()
        this.$toast.bottom('Le test du debrief est maintenant terminé')
      }
    },
    count: function () {
      let t = 0
      $('.content > .question').each(function (index) {
        if ($(this).data('required')) {
          if ($(this).is(':visible')) {
            if ($(this).has('.reponse-button').length !== 0) {
              if ($(this).find('.reponse-button').not('.check').length === $(this).find('.reponse-button').length) {
                t++
              }
            }
            if ($(this).find('.reponse-input > input').val() === '') {
              t++
            }
          }
        }
      })
      this.reponse_count = t
    },
    arbre: function (debrief) {
      let html = ''
      for (let i in debrief) {
        let required = ''
        if (debrief[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>'
        }
        html += '<div class="content debrief"><div class="question" data-required="' + debrief[i]['required'] + '" data-question-id="' + debrief[i]['question_id'] + '"> <div class="label">' + debrief[i]['question_label'] + ' ' + required + '</div>'
        for (let b in debrief[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + debrief[i]['question_id'] + '" data-reponse-id="' + debrief[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + debrief[i]['reponse'][b]['reponse_label'] + '</div>'
        }
        if (debrief[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + debrief[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>'
        }
        html += '</div>'
        for (let b in debrief[i]['reponse']) {
          if (debrief[i]['reponse'][b]['next_question'] !== null) {
            html += '<div class="child next_question_' + debrief[i]['reponse'][b]['reponse_id'] + '"> ' + this.recursive(debrief[i]['reponse'][b]['next_question'], '') + '</div>'
          }
        }
        html += '</div>'
      }
      $('.content-arbre').append(html)
      let _this = this
      $('.reponse-input > input').keyup(function () {
        _this.count()
      })
      $('.action').on('click', function () {
        // let id = $(this).data('reponse-id')
        $(this).parent().find('.action').each(function (index) {
          $(this).removeClass('check')
          $(this).find('.fa').addClass('hide')
        })
        $(this).parent().parent().find('.child').each(function (index) {
          $(this).children('.content').hide()
        })
        $(this).addClass('check')
        $(this).find('.fa').removeClass('hide')
        $(this).parent().parent().find('.child').children('.content').find('.condition').each(function (index) {
          let json = JSON.parse($(this).text())
          let ok = 0
          let count = json.length === undefined ? 0 : json.length
          for (let i in json) {
            let id = json[i]['reponse_id']
            if (json[i]['has_this_value'] === 0) {
              if (!$('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++
              }
            } else {
              if ($('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++
              }
            }
          }
          if (ok === count) {
            $(this).parent().show()
          }
        })

        _this.count()
      })

      this.count()
    },
    recursive: function (data, html) {
      for (let i in data) {
        if (i === 'null') {
          continue
        }

        let required = ''
        if (data[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>'
        }
        html += '<div class="content debrief sub hide"><div class="condition hide">' + JSON.stringify(data[i]['condition']) + '</div><div class="question" data-required="' + data[i]['required'] + '" data-question-id="' + data[i]['question_id'] + '"> <div class="label">' + data[i]['question_label'] + ' ' + required + '</div>'
        for (let b in data[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + data[i]['question_id'] + '" data-reponse-id="' + data[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + data[i]['reponse'][b]['reponse_label'] + '</div>'
        }
        if (data[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + data[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>'
        }
        html += '</div>'
        for (let b in data[i]['reponse']) {
          if (data[i]['reponse'][b]['next_question'] !== null) {
            html += '<div class="child next_question_' + data[i]['reponse'][b]['reponse_id'] + '"> ' + this.recursive(data[i]['reponse'][b]['next_question'], '') + '</div>'
          }
        }
        html += '</div>'
      }
      return html
    }
  },
  mounted: function () {
    this.$modal.hide('selector')
    let _this = this
    let data
    if (!this.isTest) {
      this.intervention_id = this.$route.params.intervention_id
      data = localStorage.getItem('debrief_' + this.intervention_id)

      this.$getItem(this.intervention_id, function (err, values) {
        if (!err) {
          _this.intervention = values
          if (_this.intervention.userAudit || _this.intervention.typeId === 18) {
            _this.audit = true
          }
        }
      })
    } else {
      this.wrapper_class = 'debrief-content-test'
      data = localStorage.getItem('debrief')
      let arbre = localStorage.getItem('arbre')
      arbre = JSON.parse(arbre)
      let values = {}
      values.rdvClient = false
      values.typeId = arbre.id
      values.etat = arbre.etat
      _this.intervention = values
      _this.intervention_id = 1231564
    }
    if (data !== undefined) {
      this.debrief = JSON.parse(data)
      this.arbre(this.debrief)
    }
    let canvas = document.getElementById('signature-pad')
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgb(0, 0, 0)'
    })
  }
}
</script>
<style>
.content.debrief{
  position: relative;
  background: #ffffff;
  margin-bottom: 10px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  box-shadow: 0 1px 1px rgba(0,0,0,0.4);
  color: #444;
  background-repeat: no-repeat;
  background-position: bottom 5px right 10px;
  background-size: 15%;
  padding: 10px 10px 10px;
  border-top: 2px solid rgb(230, 68, 68) !important;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.content.sub{
  border-top: none !important;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-left: 3%;
  margin-top: 20px;
  width: calc(100% - 3%);
  border-left: 2px solid rgb(230, 68, 68) !important;
  box-shadow: 0 1px 1px rgba(0,0,0,0.3);
}
.reponse-input
{
  margin-left: auto;
  margin-right: auto;
}
.reponse-input > input{
  text-align: center;
  padding: .48rem .75rem;
  font-size: 1rem;
  line-height: 1;
  color: #464a4c;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  display: inherit;
  background-color: #fff;
  background-image: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25rem;
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
}
#signature-pad{
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) inset;
  width:90%;
  height: 40%;
  margin-top: 10px;
}
.signature{
  position: fixed;
  text-align: center;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  color: #444;
}
.rules{
  font-size: 14px;
}
.required{
  color: green;
  font-size: 13px;
}
.content-arbre{

}
.hide{
  display: none;
}
.action.check{
  border: 1px solid green !important;
  color: white;
  background-color: green;
}
.question > .label{
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.reponse-button{
  color: rgb(230, 68, 68);
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border: 1px solid rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.5rem 0.5rem;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 5px;
}

</style>
<style scoped>
  .header-info{
    display: inline-block;
    position: absolute;
    left: 16px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    top: 71px;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    text-align: center;
  }
  .etatBox{
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 18px;
  }
  .button-content{
    position: absolute;
    right: 16px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    top: 71px;
  }
  .button-content > .button{
    display: inline-block;
    background-color: rgb(230, 68, 68) !important;
    border-color: rgb(230, 68, 68) !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0.2rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    margin-left: 10px;
  }
  .signature > div > .button{
    display: inline-block;
    background-color: rgb(230, 68, 68) !important;
    border-color: rgb(230, 68, 68) !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0.2rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    margin-left: 10px;
    color: white;
    margin-top: 20px;
  }
  .debrief-content {
    margin-top: 110px;
    padding-top: 30px;
  }
  .picture{
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    display: inline-block;
    width: 44vw;
    padding: 10px;
    margin-left: 2vw;
    margin-bottom: 2vh;
  }
  .picture > .label{
    text-align: center;
    margin-bottom: 10px;
  }
  .picture > .options{
    text-align: center;
  }
  .picture > .options > div{
    text-align: center;
    background-color: rgb(230, 68, 68);
    margin-top: 5px;
    font-size: 14px;
    padding: 5px;
    color: white;
  }
  .buttonPhoto{
    height: 50px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border: 1px solid rgb(230, 68, 68);
    width: 97%;
    margin-right: 4px;
    margin-left: auto;
    text-align: center;
    background-color: white;
    color:rgb(230, 68, 68);
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .buttonPhoto .fa{
    font-size: 15px;
    margin-top: 18px;
  }
  input[type=file] {
    display: none;
  }
  .preview{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
  .loading{
    position: fixed;
    text-align: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.7);
    z-index: 9999;
    color: white;
    top: 55px;
  }
  .loading > .label{
    padding-top: 35vh;
  }
  .title-selector{
    text-align: center;
    padding-top: 6px;
  }
  .select{
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Debrief.vue